import stellarHomes1 from "../../assets/pranav-khot-house/orchid-living-33.png";
import heroSection from "../../assets/pranav-khot-house/kids-room.png"
import stellarHomes2 from "../../assets/pranav-khot-house/orchid-kithchen-ai.png";
import bigImage from "../../assets/pranav-khot-house/orchid-tv1.png";
import stellarHomes3 from "../../assets/pranav-khot-house/orchid-kitchen02-ai.png";
import contemporaryLiving from "../../assets/pranav-khot-house/ChatGPT Image Sep 10, 2026, 12_41_28 PM.png";
import stellarHomes4 from "../../assets/pranav-khot-house/kids-study-bedroom.jpeg";
import restfulSpace from "../../assets/pranav-khot-house/finel-fan.png";
import stellarKitchenVideo from "../../assets/pranav-khot-house/stellar.mp4.mov";
import storageImage from "../../assets/pranav-khot-house/orchid-storage-detail.jpeg";

const StellarHomes = {
    title: "The Stellar Homes",
    category: "Residential / 2BHK Apartment",
    facts: [
      { label: "Location", value: "Wakad, Pune" },
      { label: "Year", value: "2026" },
      { label: "Area", value: "750 sq ft" },
      { label: "Category", value: "Residential" },
      { label: "Services", value: "Full Interior Design" },
    ],
    heroImage: heroSection,
    heroAlt: "The Stellar Homes apartment in Wakad, Pune",
    overview:
      "A compact 2BHK apartment interior designed with optimal space utilization, contemporary furnishings, and a cohesive design language. The project maximizes functionality while maintaining an open, airy feel despite the modest square footage.",
    fullbleedImage: bigImage,
    fullbleedAlt: "The Stellar Homes kitchen design",
    fullbleedQuote: "Smart design transforms compact spaces into comfortable, stylish living environments.",
    // chapters: [
    //   {
    //     eyebrow: "01 - Space Planning",
    //     title: "Maximizing Compact Living",
    //     body: "The 750 sq ft layout is carefully planned to create distinct zones for living, dining, kitchen, and bedrooms while maintaining visual connectivity and flow.",
    //     image: stellarHomes1,
    //     alt: "The Stellar Homes living area",
    //   },
    //   {
    //     eyebrow: "02 - Kitchen Design",
    //     title: "Functional Kitchen Solutions",
    //     body: "The modular kitchen is designed with efficient workflow, modern appliances, and smart storage to make cooking and daily activities seamless.",
    //     video: stellarKitchenVideo,
    //     alt: "The Stellar Homes kitchen",
    //   },
    //   {
    //     eyebrow: "03 - Bedroom Planning",
    //     title: "Restful Private Spaces",
    //     body: "Bedrooms are designed for comfort and relaxation with integrated storage solutions and thoughtful lighting to support different daily activities.",
    //     image: restfulSpace,
    //     alt: "The Stellar Homes bedroom",
    //   },
    //   {
    //     eyebrow: "04 - Finishing Details",
    //     title: "Contemporary Aesthetics",
    //     body: "Careful selection of materials, colors, and finishes creates a modern, unified aesthetic throughout the apartment that feels larger and more cohesive.",
    //     image: contemporaryLiving,
    //     alt: "The Stellar Homes finishing detail",
    //   },
    // ],
    

fullbleedImage2: storageImage,
fullbleedAlt2: "The Stellar Homes storage design",
fullbleedQuote2: "Thoughtful storage solutions throughout the apartment ensure everything has its place, creating a clutter-free environment that feels spacious and organized.",


    chapters: [
  {
    eyebrow: "01 - LIVING",
    title: "Small Space, Big Impact",
    body: "Smart planning brings the living area together with clean lines, integrated storage and effortless movement.",
    image: stellarHomes1,
    alt: "The Stellar Homes contemporary living area",
  },
  {
    eyebrow: "02 - KITCHEN",
    title: "Designed for Everyday Ease",
    body: "A practical modular kitchen combines smart storage with a layout that keeps everyday cooking simple and efficient.",
    video: stellarKitchenVideo,
    alt: "The Stellar Homes modular kitchen",
  },
  {
    eyebrow: "03 - LIVING & DINING",
    title: "Made for Everyday Moments",
    body: "A seamless living and dining setup creates an inviting space to relax, gather and enjoy time together.",
    image: restfulSpace,
    alt: "The Stellar Homes living and dining area",
  },
  {
    eyebrow: "04 - ENTRY",
    title: "The Details Make the Difference",
    body: "Layered lighting, thoughtful storage and refined finishes give the entrance a warm and distinctive character.",
    image: contemporaryLiving,
    alt: "The Stellar Homes entrance and storage design",
  },

//  {
//     eyebrow: "05 - Storage",
//     title: "The Details Make the Difference",
//     body: "Thoughtful storage solutions throughout the apartment ensure everything has its place, creating a clutter-free environment that feels spacious and organized.",
//     image: storageImage,
//     alt: "The Stellar Homes storage design",
//   },

],
    
    gallery: [

      {
        image: storageImage,
        alt: "The Stellar Homes storage design",
        caption: "Thoughtful storage solutions throughout the apartment",
      },

      {
        image: stellarHomes1,
        alt: "The Stellar Homes living area with TV wall and storage",
        caption: "Living area with integrated storage and TV wall",
      },
      {
        image: stellarHomes2,
        alt: "The Stellar Homes compact modular kitchen",
        caption: "Compact modular kitchen planned for daily use",
      },
      {
        image: stellarHomes4,
        alt: "The Stellar Homes kids study bedroom",
        caption: "Kids study bedroom with practical furniture planning",
      },
      // {
      //   image: stellarHomes3,
      //   alt: "The Stellar Homes alternate kitchen view",
      //   caption: "Kitchen storage and finish detail",
      // },

 

    ],
  };

export default StellarHomes;
